import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import viewAction from "../../assests/images/viewAction.png";
import threeDots from "../../assests/images/threeDots.png";
import { Checkbox } from "primereact/checkbox";
import arrowLeft from "../../assests/images/arrow-circle-left.png";
import arrowRight from "../../assests/images/arrow-circle-right.png";
import { Badge } from "primereact/badge";
import { OverlayPanel } from "primereact/overlaypanel";
import { capitalizeFirstLetter } from "../utils/commonFunction";
import { Dropdown } from "primereact/dropdown";
import { CustomTooltip } from "./CommonTooltip";
//
// parent component
const CommmonTable = ({
  dataContent,
  currentPage,
  totalPages,
  popupOption,
  popupOptionText,
  headerTranslations,
  headerOrder,
  additionalRow,
  showViewButton = false,
  showDeleteButton = false,
  onViewData,
  onRegisterData,
  tableHeader,
  handleNextPage,
  handlePreviousPage,
  totalItems,
  popupOptionStructure,
  popupOptionPharmacy,
  popupOptionRetail,
  itemsPerPage = 10,
  handleItemsPerPage,
  handlePageClick,
}) => {

  const [tableValueContent, setTableValueContent] = useState(dataContent);
  const [isGlobalSearchVisible, setIsGlobalSearchVisible] = useState(false);
  const [filteredContent, setFilteredContent] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedValue, setSelectedValue] = useState(itemsPerPage);
  const options = [10, 25, 50, 100].map((value) => ({ label: value, value }));

  const excludeHeaders = [
    "qtmAdminId",
    "isActive",
    "zipCode",
    "roleId",
    "roleName",
    "authenticationName",
    "authenticationType",
    "profileImg",
    "countryCode",
    "countryFlag",
    "countryId",
    "id",
    "phoneCode",
    "cityId",
    "regionId",
    "addressId",
    "province",
    "status",
  ];

  useEffect(() => {
    setFilteredContent(dataContent)
  }, [dataContent])

  const filteredTableHeader = tableHeader?.filter((col) => !excludeHeaders?.includes(col))?.sort((a, b) => headerOrder?.indexOf(a) - headerOrder?.indexOf(b));
  const overlayPanelRef = useRef(null);
  useEffect(() => {
    setSelectedValue(itemsPerPage);
  }, [itemsPerPage]);

  const viewButtonTemplate = (rowData) => {
    if (showViewButton) {
      return (
        <img
          src={viewAction}
          alt="edit"
          onClick={() =>
            rowData?.status !== "to activate" && onViewData(rowData)
          }
          className={`edit-action pointer ${rowData?.status === "to activate" ? "disabled" : ""
            }`}
          style={{
            cursor:
              rowData?.status === "to activate" ? "not-allowed" : "pointer",
            opacity: rowData?.status === "to activate" ? 0.5 : 1,
          }}
        />
      );
    }
    return null;
  };

  const optionButtonTemplate = (rowData) => {
    if (showDeleteButton) {
      return (
        <img
          src={threeDots}
          alt="edit"
          onClick={(e) => handleThreeDotsClick(e, rowData)}
          className="edit-action pointer"
        />
      );
    }
    return null;
  };

  const handleAddRow = () => {
    const newRow = tableHeader.reduce((row, col) => {
      row[col] = "";
      return row;
    }, {});
    newRow.id = tableValueContent.length + 1;
    setTableValueContent([...tableValueContent, newRow]);
  };

  const fetchStructureData = (hospitalList = [], textString = "") => {
    let valueData = textString === "hospital"
      ? hospitalList.map((hospital) => hospital.name)
      : hospitalList.map((hospital) => hospital.pharmacyName);

    return (
      <CustomTooltip
        isView={valueData.length > 1}
        content={
          <ul className="tooltip-list">
            {valueData.map((each, idx) => (
              <li key={idx}>{each}{idx !== valueData?.length - 1 ? ',' : ''}</li>
            ))}
          </ul>
        }
      >
        <span>
          {valueData.length > 1 ? valueData.slice(0, 1).join(", ") + "..." : valueData.join(", ")}
        </span>
      </CustomTooltip>
    );
  };

  const onGetCompanyName = (
    regionName = "",
    municipality = "",
    companyName = ""
  ) => [regionName, municipality, companyName].filter(Boolean).join(", ") || "";

  const onHandleReturnData = (rowData, col) => {
    const value = rowData[col];
    if (col === "companyName") {
      return onGetCompanyName(
        rowData?.companyName
      );
    } else if (col === "phoneNumber") {
      return value?.startsWith("+") ? value : `+${value}`;
    } else if (col === "phone") {
      return value?.startsWith("+") ? value : `+${value}`;
    } else if (col === "hospital") {
      return fetchStructureData(rowData?.hospital, "hospital");
    } else if (col === "pharmacy") {
      return fetchStructureData(rowData?.pharmacy, "pharmacy");
    }
    else if (col === "asl") {
      return rowData?.companyName;
    } else {
      return value;
    }
  };

  const dynamicColumns = filteredTableHeader?.map((col, index) => {
    if (col === "firstName") {
      return (
        <Column
          key={"fullName"}
          field={"fullName"}
          header={
            !isGlobalSearchVisible ? (
              <div style={{ textAlign: "left", paddingLeft: "30px" }}>
                NOME COGNOME
              </div>
            ) : null
          }
          body={(rowData) => {
            const firstName = rowData["firstName"] || "";
            const lastName = rowData["lastName"] || "";
            return `${capitalizeFirstLetter(firstName)} ${capitalizeFirstLetter(
              lastName
            )}`;
          }}
          bodyStyle={{ textAlign: "left", paddingLeft: "50px" }}
          className="equal-spacing-column"
          style={{ width: "150px", textAlign: "left", paddingLeft: "20px" }}
        />
      );
    }
    //
    if (col === "lastName") return null;
    if (["dd", "dpc", "inPharmacy"].includes(col)) {
      return (
        <Column
          key={col}
          field={col}
          header={headerTranslations[col] || col}
          body={(rowData) => checkboxTemplate(rowData, col)}
          bodyStyle={{ textAlign: "center" }}
          className="equal-spacing-column"
          style={{ width: "100px", textAlign: "center" }}
        />
      );
    }
    const formattedHeader = headerTranslations[col] || col;
    return (
      <Column
        key={index}
        field={col}
        header={
          !isGlobalSearchVisible ? (
            <div style={{ textAlign: "left", paddingLeft: "40px" }}>
              {formattedHeader}
            </div>
          ) : null
        }
        filterPlaceholder={`Search by ${col?.toLowerCase()}`}
        body={(rowData) => onHandleReturnData(rowData, col)}
        bodyStyle={{ textAlign: "left", paddingLeft: "60px" }}
        className="equal-spacing-column"
        style={{ width: "150px", textAlign: "left" }}
      />
    );
  });

  const handleThreeDotsClick = (event, rowData) => {
    setSelectedRowData(rowData);
    overlayPanelRef.current?.toggle(event);
  };

  const handleOptionClick = (option) => {
    if (onRegisterData) {
      onRegisterData({ action: option, ...selectedRowData });
    }
    overlayPanelRef.current.hide();
  };

  const getPaginationNumbers = (
    currentPage,
    totalPages,
    maxPageNumbersToShow = 5
  ) => {
    let pages = [];

    if (totalPages <= maxPageNumbersToShow) {
      // Show all pages if total pages are within limit
      pages = Array.from({ length: totalPages }, (_, index) => index + 1);
    } else {
      // Always show first, last, and surrounding pages
      if (currentPage <= 3) {
        pages = [1, 2, 3, 4, 5, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        pages = [
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages,
        ];
      } else {
        pages = [
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages,
        ];
      }
    }

    return pages;
  };

  const renderCustomPagination = () => {
    const paginationNumbers = getPaginationNumbers(currentPage, totalPages);
    return (
      <div className="pagination-container d-flex justify-content-between align-items-center me-3 w-100">
        {/* Left Side: Items per page dropdown */}
        <div className="pagination-dropdown d-flex align-items-center">
          <label className="me-2">Show</label>
          <Dropdown
            value={selectedValue}
            options={options}
            onChange={(e) => {
              setSelectedValue(e.value);
              handleItemsPerPage && handleItemsPerPage(e.value);
            }}
            className="p-dropdown-sm"
            placeholder="Select"
          />
        </div>

        <div className="pagination-info text-center">
          {`Mostrando ${(currentPage - 1) * selectedValue + 1} - ${Math.min(
            currentPage * selectedValue,
            totalItems
          )} di ${totalItems} ${"elementi"}`}
        </div>
        <div className="pagination-controls d-flex align-items-center">
          <img
            src={arrowLeft}
            alt="Previous"
            className={`pagination-icon pointer ${currentPage === 1 ? "disabled" : ""
              }`}
            onClick={() =>

              currentPage > 1 && handlePreviousPage(currentPage - 1)
            }
          />
          <div className="pagination-pages mx-2">
            {paginationNumbers.map((page, index) => (
              <span
                key={index}
                className={`pagination-page-number ${currentPage === page ? "active" : ""
                  }`}
                onClick={() =>
                  page !== "..." && handlePageClick(page)
                }
              >
                {page}
              </span>
            ))}
          </div>

          <img
            src={arrowRight}
            alt="Next"
            className={`pagination-icon pointer ${currentPage === totalPages ? "disabled" : ""
              }`}
            onClick={() =>
              currentPage < totalPages && handleNextPage(currentPage + 1)
            }
          />
        </div>
      </div>
    );
  };

  const checkboxTemplate = (rowData, field) => {
    return (
      <Checkbox
        className="custom-checkbox"
        checked={rowData[field] === true}
      />
    );
  };

  return (
    <>
      <div>
        <DataTable
          value={filteredContent}
          className="p-datatable-gridlines custom-table custom-datatable equal-spacing-table ms-4 me-4 hide-scrollbar"
          showGridlines
          dataKey="id"
          rowHover
          responsiveLayout="scroll"
          footerClassName="p-datatable-footer p-d-flex p-jc-end"
          scrollable
          scrollHeight="80vh"
          footer={renderCustomPagination()}
          tableStyle={{ minHeight: '10rem' }}
        >

          {dynamicColumns}
          {filteredContent?.some((row) => "isActive" in row) && (
            <Column
              field="isActive"
              header={
                !isGlobalSearchVisible && (
                  <div style={{ textAlign: "center", width: "70%" }}>
                    STATUS
                  </div>
                )
              }
              body={(rowData) => (
                <div className="text-align-center">
                  <Badge
                    style={{ display: "flex", justifyContent: "center" }}
                    value={
                      rowData.isActive === true
                        ? "attivo"
                        : rowData.isActive === false
                          ? "inattivo"
                          : ""
                    }
                    className={
                      rowData.isActive === true
                        ? "badge-inner badge-color-success badge-spacious"
                        : rowData?.isActive === false
                          ? "badge-inner badge-color-error badge-spacious"
                          : ""
                    }
                  />
                </div>
              )}
              className="equal-spacing-column"
              style={{ width: "150px", textAlign: "left" }}
            />
          )}

          {filteredContent?.some((row) => "status" in row) && (
            <Column
              field="status"
              header={
                !isGlobalSearchVisible && (
                  <div style={{ textAlign: "center", width: "58%" }}>
                    STATUS
                  </div>
                )
              }
              body={(rowData) => (
                <div className="text-align-center">
                  <Badge
                    value={
                      rowData.status === "active"
                        ? "attivo"
                        : rowData.status === "inactive"
                          ? "inattivo"
                          : rowData.status === "to activate"
                            ? "da attivare"
                            : ""
                    }
                    className={
                      rowData.status === "active"
                        ? "badge-inner badge-color-success badge-spacious"
                        : rowData?.status === "inactive"
                          ? "badge-inner badge-color-error badge-spacious"
                          : rowData?.status === "to activate"
                            ? "badge-inner badge-color-warning badge-spacious"
                            : ""
                    }
                  />
                </div>
              )}
              className="equal-spacing-column"
              style={{ width: "150px", textAlign: "left" }}
            />
          )}
          {additionalRow && (
            <Column
              header={
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <i
                    className="pi pi-plus add-row-icon pointer"
                    title="Add Row"
                    style={{ cursor: "pointer", textAlign: "left" }}
                    onClick={handleAddRow}
                  />
                </div>
              }
              className="equal-spacing-column"
              style={{ width: "150px", textAlign: "left" }}
            />
          )}

          {(showViewButton || showDeleteButton) && (
            <Column
              body={(rowData) => (
                <div className="row">
                  <div className="col-lg-2 col-md-2 me-4">
                    {viewButtonTemplate(rowData)}
                  </div>
                  {optionButtonTemplate(rowData)}
                </div>
              )}
              className="equal-spacing-column"
              style={{ width: "150px", textAlign: "left" }}
            />
          )}
        </DataTable>
        {popupOption && (
          <OverlayPanel ref={overlayPanelRef} className="custom-overlay-panel">
            <div className="popover-menu">
              {!popupOptionText ? (
                <div
                  className="popover-option"
                  onClick={() => handleOptionClick("Attiva Assistito")}
                >
                  Attiva/Disattiva
                </div>
              ) : (
                <>
                  <div
                    className="popover-option"
                    onClick={() => handleOptionClick("Attiva/Disattiva")}
                  >
                    Attiva/Disattiva
                  </div>
                  <div
                    className="popover-option"
                    onClick={() => handleOptionClick("Modifica")}
                  >
                    Modifica
                  </div>
                </>
              )}

              {
                !popupOptionText && (
                  <div
                    className="popover-option"
                    onClick={() => handleOptionClick("Modifica Assistito")}
                  >
                    Modifica Assistito
                  </div>
                )
              }
            </div>
          </OverlayPanel>
        )}
        {popupOptionStructure && (
          <OverlayPanel ref={overlayPanelRef} className="custom-overlay-panel">
            <div className="popover-menu">
              <div
                className="popover-option"
                onClick={() => handleOptionClick("Attiva/Disattiva")}
              >
                Attiva/Disattiva
              </div>
              <div
                className="popover-option"
                onClick={() => handleOptionClick("Modifica Struttura")}
              >
                Modifica Struttura
              </div>
            </div>
          </OverlayPanel>
        )}

        {popupOptionPharmacy && (
          <OverlayPanel ref={overlayPanelRef} className="custom-overlay-panel">
            <div className="popover-menu">
              <div
                className="popover-option"
                onClick={() => handleOptionClick("Attiva/DisattivaPharmacy")}
              >
                Attiva/Disattiva
              </div>
              <div
                className="popover-option"
                onClick={() => handleOptionClick("Modifica Pharmacy")}
              >
                Modifica Farmacie
              </div>
            </div>
          </OverlayPanel>
        )}

        {popupOptionRetail && (
          <OverlayPanel ref={overlayPanelRef} className="custom-overlay-panel">
            <div className="popover-menu">
              <div
                className="popover-option"
                onClick={() => handleOptionClick("Attiva/DisattivaRetail")}
              >
                Attiva/Disattiva
              </div>
              <div
                className="popover-option"
                onClick={() => handleOptionClick("Modifica Retail")}
              >
                Modifica Farmacie Retail
              </div>
            </div>
          </OverlayPanel>
        )}
      </div>
    </>
  );
};

export default CommmonTable;
// future use for checkbox list in starting
// const isAllSelected = tableValueContent?.length > 0 && selectedRows?.length === tableValueContent?.length;
// const handleRowSelection = (e, rowData) => {
//   let updatedSelectedRows;
//   if (e.checked) {
//     updatedSelectedRows = [...selectedRows, rowData];
//   } else {
//     updatedSelectedRows = selectedRows.filter(
//       (item) => item.id !== rowData.id
//     );
//   }
//   setSelectedRows(updatedSelectedRows);
// };
// const handleSelectAll = (e) => {
//   if (e.checked) {
//     setSelectedRows(tableValueContent);
//   } else {
//     setSelectedRows([]);
//   }
// };
// {checkboxStatus && (
//   <Column
//     header={
//       <div style={{ textAlign: 'center' }}>
//         <Checkbox
//           checked={isAllSelected}
//           onChange={handleSelectAll}
//           className="custom-checkbox"
//         />
//       </div>
//     }
//     body={(rowData) => (
//       <Checkbox
//         className="custom-checkbox"
//         checked={selectedRows.some((item) => item.id === rowData.id)}
//         onChange={(e) => handleRowSelection(e, rowData)}
//       />
//     )}
//     style={{ width: '10px', textAlign: 'center' }}
//   />
// )}
